import useFlag from 'lane-shared/hooks/useFlag';

import { FeatureFlag } from 'constants-flags';

export function useInspectionWorkOrderIntegrationEnabled() {
  const isEnabled = useFlag<boolean>(
    FeatureFlag.InspectionsWorkOrderIntegration,
    false
  );

  return Boolean(isEnabled);
}
